/**
 * @desc 界面管理
 * @author zl zhaolun@qfei.cn
 * @date 2024年01月04日09:55:54
 */
export default {
  界面管理: '界面管理',
  菜单界面管理: '菜单界面管理',
  菜单项管理: '菜单项管理',
  菜单界面名称: '菜单界面名称',
  菜单项名称: '菜单项名称',
  基本设置: '基本设置',
  菜单项类型: '菜单项类型',
  菜单图标: '菜单图标',
  请选择菜单图标: '请选择菜单图标',
  请输入菜单项名称: '请输入菜单项名称',
  '请输入API Name': '请输入API Name',
  请选择菜单项: '请选择菜单项',
  可选: '可选',
  分组: '分组',
  创建分组: '创建分组',
  自定义对象: '自定义对象',
  自定义菜单: '自定义菜单',
  分组名称: '分组名称',
  分组不能拖动到其他分组下: '分组不能拖动到其他分组下',
  '菜单不能含有子菜单，请创建分组': '菜单不能含有子菜单，请创建分组',
  请选择菜单: '请选择菜单',
  其他菜单: '其他菜单',
  页面名称: '页面名称',
  请输入页面名称: '请输入页面名称',
  打开方式: '打开方式',
  请选择打开方式: '请选择打开方式',
  新页面打开: '新页面打开',
  内嵌页面打开: '内嵌页面打开',
  '内嵌页面打开时，只支持https开头的链接': '内嵌页面打开时，只支持https开头的链接',
  设置容器在详情页显示时的外边框: '设置容器在详情页显示时的外边框',
  自定义页面管理: '自定义页面管理',
  电脑端链接: '电脑端链接',
  手机端链接: '手机端链接',
  请输入页面链接: '请输入页面链接',
  '请输入完整的页面链接，以http或https开头，否则将无法保存': '请输入完整的页面链接，以http或https开头，否则将无法保存',
  '烽火域名不可被作为外链使用，请检查！': '烽火域名不可被作为外链使用，请检查！',
  请输入正确的电脑端链接: '请输入正确的电脑端链接',
  请输入正确的移动端链接: '请输入正确的移动端链接',
  '请确认是否删除该条数据？': '请确认是否删除该条数据？',
  自定义页面: '自定义页面',
  外链容器: '外链容器',
  容器名称: '容器名称',
  电脑端外链地址: '电脑端外链地址',
  移动端外链地址: '移动端外链地址',
  外框类型: '外框类型',
  实线: '实线',
  虚线: '虚线',
  无: '无',
  显示高度: '显示高度'
};
